import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Flag } from 'src/app/gws/administration/archive/flags/models/flag.model';
import { BaseService } from '../BaseService';

@Injectable({
  providedIn: 'root',
})
export class FlagService extends BaseService {

  protected urlPath = '/v1/archive-flags';

  getFlags(): Observable<Flag[]> {
    return this._http
      .get<Flag[]>(this.getFullUrl('archive-flags'))
      .pipe(map((res: any) => res.rows));
  }

  getEmailTrackerFlags(): Observable<Flag[]> {
    return this._http
      .get<Flag[]>('/v1/archive-messages/flags?page=1&per-page=1000')
      .pipe(map((res: any) => res.rows));
  }
}
